import { mapState, mapGetters, mapActions } from 'vuex'

export const qrSecretComputed = {
  ...mapState('qrSecret', {}),
  ...mapGetters('qrSecret', [
    'qrCode',
    'qrCodeSuccess',
    'isLoadingSendQr',
    'sendQrCodeSuccess',
    'getIsLoadingQrCode',
    'getSecret',
  ]),
}

export const qrSecretMethods = mapActions('qrSecret', [
  'getQrCode',
  'sendQrCode',
  'resetSecret',
])
